import { fork } from 'redux-saga/effects';

import { actions } from 'domain/substrate';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Substrate', actions, editableFields }, args);
}
